module.exports = __webpack_public_path__ + "static/illustration-footer-m-29b9dc4f566954b8f081bc3fbfc4ce76.svg";